import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(detail)/$auditId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/audits/$auditId/overview',
      params: { auditId: params.auditId },
    });
  },
});
